import React, { createContext, useContext, useState } from "react";
import { CanvasContext } from "./CanvasContext";

const PropertyContext = createContext();

const PropertyProvider = ({ children }) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedlabelImage, setSelectedlabelImage] = useState("");
  const [selectedHoveredImage, setSelectedHoveredImage] = useState("");
  const [selectedFocusedImage, setSelectedFocusedImage] = useState("");
  const [selectedActivatedImage, setSelectedActivatedImage] = useState("");
  const { files, setShowFileManager } = useContext(CanvasContext);

  const styles = {
    container: {
      padding: "8px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      backgroundColor: "#f9f9f9",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      margin: "20px auto",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      overflow: "hidden",
    },
    button: {
      marginTop: "5px",
      padding: "8px",
      backgroundColor: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    heading: {
      fontSize: "15px",
      marginBottom: "10px",
      color: "#333",
      borderBottom: "1px solid #ddd",
      paddingBottom: "5px",
    },
    inputGroup: {
      marginBottom: "10px",
    },
    label: {
      display: "block",
      marginBottom: "5px",
      fontWeight: "bold",
      color: "#555",
    },
    input: {
      width: "100%",
      padding: "4px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxSizing: "border-box",
    },

    select: {
      width: "100%",
      padding: "3px 5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxSizing: "border-box",
    },
    animationButton: {
      width: "100%",
      padding: "10px",
      backgroundColor: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
  };
  const renderLabelPaddingProperties = (renderMutableInput) => {
    return (
      <div key="Label-Padding-properties" style={styles.inputGroup}>
        {renderMutableInput("Padding Label", "labelpadding", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Top Label", "labelpaddingTop", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Right Label", "labelpaddingRight", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Bottom Label", "labelpaddingBottom", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Left Label", "labelpaddingLeft", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
      </div>
    );
  };
  const renderLabelMarginProperties = (renderMutableInput) => {
    return (
      <div key="Label-Margin-properties" style={styles.inputGroup}>
        {renderMutableInput("Margin label", "labelmargin", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Top label", "labelmarginTop", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Right label", "labelmarginRight", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Bottom label", "labelmarginBottom", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Left label", "labelmarginLeft", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
      </div>
    );
  };
  const renderLabelBorderProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="Label-Border-properties" style={styles.inputGroup}>
        {renderMutableInput("Border Label", "labelborder", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Bottom Label", "labelborderBottom", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Top Label", "labelborderTop", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Left Label", "labelborderLeft", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Right Label", "labelborderRight", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderInput("Border Radius Label", "labelborderRadius")}
        {renderInput("Border Spacing Label", "labelborderSpacing")}
        {renderSelect("Border Collapse Label", "labelborderCollapse", [
          "collapse",
          "separate",
        ])}
        {renderInput("Outline Label", "labeloutline")}
      </div>
    );
  };
  const renderLabelPositionProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="Label-Position-properties" style={styles.inputGroup}>
        {renderSelect("Position Label", "labelposition", [
          "static",
          "relative",
          "absolute",
          "fixed",
          "sticky",
        ])}

        {renderMutableInput("Top Label", "labeltop", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Right Label", "labelright", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Bottom Label", "labelbottom", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Left Label", "labelleft", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}

        {renderInput("Z-Index Label", "labelzIndex")}
      </div>
    );
  };
  const renderLabelBackgroundProperties = (
    renderSelect,
    searchTerm,
    handleChange,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "background".includes(searchTerm.toLowerCase()) ||
        "label".includes(searchTerm.toLowerCase()) ||
        "image".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    const handleImageSelect = (imageName) => {
      setSelectedlabelImage(imageName);
      handleChange({
        target: {
          name: "labelbackgroundImage",
          value: `./${imageName}`,
        },
      });
    };

    return (
      <div key="label-background-properties" style={styles.inputGroup}>
        <div>
          <label style={styles.label}>Background Image label URL: </label>
          <input
            type="text"
            name="labelbackgroundImage"
            value={selectedDiv ? selectedDiv.labelbackgroundImage : ""}
            onChange={handleChange}
            placeholder="Enter URL or select from File Manager"
            style={styles.input}
          />
          <button
            onClick={() => setShowFileManager(true)}
            style={styles.button}
          >
            Open File Manager
          </button>
        </div>
        {files.length > 0 && (
          <div style={styles.imageSelector}>
            <label style={styles.label}>Select an image:</label>
            <select
              onChange={(e) => handleImageSelect(e.target.value)}
              value={selectedlabelImage || ""}
              style={styles.select}
            >
              <option value="">Choose an image</option>
              {files
                .filter((file) => file.type.startsWith("image/"))
                .map((file) => (
                  <option key={file.id} value={file.name}>
                    {file.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {renderSelect("Background Repeat label", "labelbackgroundRepeat", [
          "repeat",
          "no-repeat",
          "repeat-x",
          "repeat-y",
          "space",
          "round",
        ])}
        {renderSelect("Background Position label", "labelbackgroundPosition", [
          "left top",
          "left center",
          "left bottom",
          "right top",
          "right center",
          "right bottom",
          "center top",
          "center center",
          "center bottom",
        ])}
        {renderSelect("Background Size label", "labelbackgroundSize", [
          "auto",
          "cover",
          "contain",
        ])}
        {renderSelect(
          "Background Attachment label",
          "labelbackgroundAttachment",
          ["scroll", "fixed", "local"]
        )}
        {renderSelect("Background Clip label", "labelbackgroundClip", [
          "border-box",
          "padding-box",
          "content-box",
        ])}
      </div>
    );
  };
  const renderLabelGradientProperties = (
    renderSelect,
    searchTerm,
    renderInput,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "gradient".includes(searchTerm.toLowerCase()) ||
        "background".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }
    return (
      <div key="gradient-properties-label" style={styles.inputGroup}>
        {renderSelect(
          "Background Gradient label",
          "labelbackgroundGradientImage",
          [
            "none",
            "linear-gradient",
            "radial-gradient",
            "repeating-linear-gradient",
            "repeating-radial-gradient",
          ]
        )}

        {selectedDiv &&
          selectedDiv.labelbackgroundGradientImage === "linear-gradient" && (
            <>
              {renderSelect(
                "Gradient Direction label",
                "labelgradientDirection",
                [
                  "to right",
                  "to bottom",
                  "to left",
                  "to top",
                  "to top right",
                  "to top left",
                  "to bottom right",
                  "to bottom left",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.labelbackgroundGradientImage === "radial-gradient" && (
            <>
              {renderSelect("Gradient Shape label", "labelgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position label",
                "labelgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.labelbackgroundGradientImage ===
            "repeating-linear-gradient" && (
            <>
              {renderInput(
                "Gradient Angle (deg) label",
                "labelgradientAngle",
                "number"
              )}
              {renderInput(
                "Pattern Length label",
                "labelpatternLength",
                "number"
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.labelbackgroundGradientImage ===
            "repeating-radial-gradient" && (
            <>
              {renderSelect("Gradient Shape label", "labelgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position label",
                "labelgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
              {renderInput(
                "Pattern Length label",
                ";labelpatternLength",
                "number"
              )}
            </>
          )}

        {renderInput("start Color label", "labelstartColor", "color")}
        {renderInput("End Color label", "labelendColor", "color")}
      </div>
    );
  };

  const renderMarginProperties = (renderMutableInput) => {
    return (
      <div key="Margin-properties" style={styles.inputGroup}>
        {renderMutableInput("Margin", "margin", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Top", "marginTop", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Right", "marginRight", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Bottom", "marginBottom", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Left", "marginLeft", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
      </div>
    );
  };
  const renderHoveredMarginProperties = (renderMutableInput) => {
    return (
      <div key="HoveredMargin-properties" style={styles.inputGroup}>
        {renderMutableInput("Margin Hover", "hoveredmargin", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Top Hover", "hoveredmarginTop", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Right Hover", "hoveredmarginRight", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Bottom Hover", "hoveredmarginBottom", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Left Hover", "hoveredmarginLeft", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
      </div>
    );
  };
  const renderFocusedMarginProperties = (renderMutableInput) => {
    return (
      <div key="FocusedMargin-properties" style={styles.inputGroup}>
        {renderMutableInput("Margin Focus", "focusedmargin", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Top Focus", "focusedmarginTop", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Right Focus", "focusedmarginRight", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Bottom Focus", "focusedmarginBottom", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Left Focus", "focusedmarginLeft", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
      </div>
    );
  };
  const renderActivatedMarginProperties = (renderMutableInput) => {
    return (
      <div key="ActivatedMargin-properties" style={styles.inputGroup}>
        {renderMutableInput("Margin Active", "activatedmargin", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Top Active", "activatedmarginTop", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Right Active", "activatedmarginRight", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Bottom Active", "activatedmarginBottom", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
        {renderMutableInput("Margin Left Active", "activatedmarginLeft", [
          "0",
          "2rem",
          "2em",
          "20px",
          "2%",
        ])}
      </div>
    );
  };
  const renderPaddingProperties = (renderMutableInput) => {
    return (
      <div key="Padding-properties" style={styles.inputGroup}>
        {renderMutableInput("Padding", "padding", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Top", "paddingTop", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Right", "paddingRight", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Bottom", "paddingBottom", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Left", "paddingLeft", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
      </div>
    );
  };
  const renderHoveredPaddingProperties = (renderMutableInput) => {
    return (
      <div key="hoveredPadding-properties" style={styles.inputGroup}>
        {renderMutableInput("Padding Hover", "hoveredpadding", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Top Hover", "hoveredpaddingTop", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Right Hover", "hoveredpaddingRight", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Bottom Hover", "hoveredpaddingBottom", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Left Hover", "hoveredpaddingLeft", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
      </div>
    );
  };
  const renderFocusedPaddingProperties = (renderMutableInput) => {
    return (
      <div key="FocusedPadding-properties" style={styles.inputGroup}>
        {renderMutableInput("Padding Focus", "focusedpadding", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Top Focus", "focusedpaddingTop", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Right Focus", "focusedpaddingRight", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Bottom Focus", "focusedpaddingBottom", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Left Focus", "focusedpaddingLeft", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
      </div>
    );
  };
  const renderActivatedPaddingProperties = (renderMutableInput) => {
    return (
      <div key="ActivatedPadding-properties" style={styles.inputGroup}>
        {renderMutableInput("Padding Active", "activatedpadding", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Top Active", "activatedpaddingTop", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Right Active", "activatedpaddingRight", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Bottom Active", "activatedpaddingBottom", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
        {renderMutableInput("Padding Left Active", "activatedpaddingLeft", [
          "0",
          "2rem",
          "2em",
          "8px",
          "2%",
        ])}
      </div>
    );
  };
  const renderBorderProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="Border-properties" style={styles.inputGroup}>
        {renderMutableInput("Border", "border", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Bottom", "borderBottom", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Top", "borderTop", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Left", "borderLeft", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Right", "borderRight", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderInput("Border Radius", "borderRadius")}
        {renderInput("Border Spacing", "borderSpacing")}
        {renderSelect("Border Collapse", "borderCollapse", [
          "collapse",
          "separate",
        ])}
        {renderInput("Outline", "outline")}
      </div>
    );
  };
  const renderHoveredBorderProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="hoveredBorder-properties" style={styles.inputGroup}>
        {renderMutableInput("Border Hover", "hoveredborder", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Bottom Hover", "hoveredborderBottom", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Top Hover", "hoveredborderTop", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Left Hover", "hoveredborderLeft", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Right Hover", "hoveredborderRight", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderInput("Border Radius Hover", "hoveredborderRadius")}
        {renderInput("Border Spacing Hover", "hoveredborderSpacing")}
        {renderSelect("Border Collapse Hover", "hoveredborderCollapse", [
          "collapse",
          "separate",
        ])}
        {renderInput("Outline Hover", "hoveredoutline")}
      </div>
    );
  };
  const renderFocusedBorderProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="FocusedBorder-properties" style={styles.inputGroup}>
        {renderMutableInput("Border Focus", "focusedborder", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Bottom Focus", "focusedborderBottom", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Top Focus", "focusedborderTop", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Left Focus", "focusedborderLeft", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Right Focus", "focusedborderRight", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderInput("Border Radius Focus", "focusedborderRadius")}
        {renderInput("Border Spacing Focus", "focusedborderSpacing")}
        {renderSelect("Border Collapse Focus", "focusedborderCollapse", [
          "collapse",
          "separate",
        ])}
        {renderInput("Outline Focus", "focusedoutline")}
      </div>
    );
  };
  const renderActivatedBorderProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="ActivatedBorder-properties" style={styles.inputGroup}>
        {renderMutableInput("Border Active", "activatedborder", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Bottom Active", "activatedborderBottom", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Top Active", "activatedborderTop", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Left Active", "activatedborderLeft", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderMutableInput("Border Right Active", "activatedborderRight", [
          "none",
          "1px solid #000000",
          "2px dashed #000000",
        ])}
        {renderInput("Border Radius Active", "activatedborderRadius")}
        {renderInput("Border Spacing Active", "activatedborderSpacing")}
        {renderSelect("Border Collapse Active", "activatedborderCollapse", [
          "collapse",
          "separate",
        ])}
        {renderInput("Outline Active", "activatedoutline")}
      </div>
    );
  };

  const renderPositionProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="Position-properties" style={styles.inputGroup}>
        {renderSelect("Position", "position", [
          "static",
          "relative",
          "absolute",
          "fixed",
          "sticky",
        ])}

        {renderMutableInput("Top", "top", ["0", "2rem", "2em", "10px", "10%"])}
        {renderMutableInput("Right", "right", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Bottom", "bottom", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Left", "left", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}

        {renderInput("Z-Index", "zIndex")}
      </div>
    );
  };
  const renderHoveredPositionProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="HoveredPosition-properties" style={styles.inputGroup}>
        {renderSelect("Position Hover", "hoveredposition", [
          "static",
          "relative",
          "absolute",
          "fixed",
          "sticky",
        ])}

        {renderMutableInput("Top Hover", "hoveredtop", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Right Hover", "hoveredright", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Bottom Hover", "hoveredbottom", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Left Hover", "hoveredleft", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}

        {renderInput("Z-Index Hover", "hoveredzIndex")}
      </div>
    );
  };
  const renderFocusedPositionProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="FocusedPosition-properties" style={styles.inputGroup}>
        {renderSelect("Position Focus", "focusedposition", [
          "static",
          "relative",
          "absolute",
          "fixed",
          "sticky",
        ])}

        {renderMutableInput("Top Focus", "focusedtop", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Right Focus", "focusedright", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Bottom Focus", "focusedbottom", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Left Focus", "focusedleft", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}

        {renderInput("Z-Index Focus", "focusedzIndex")}
      </div>
    );
  };
  const renderActivatedPositionProperties = (
    renderMutableInput,
    renderInput,
    renderSelect
  ) => {
    return (
      <div key="ActivatedPosition-properties" style={styles.inputGroup}>
        {renderSelect("Position Active", "activatedposition", [
          "static",
          "relative",
          "absolute",
          "fixed",
          "sticky",
        ])}

        {renderMutableInput("Top Active", "activatedtop", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Right Active", "activatedright", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Bottom Active", "activatedbottom", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}
        {renderMutableInput("Left Active", "activatedleft", [
          "0",
          "2rem",
          "2em",
          "10px",
          "10%",
        ])}

        {renderInput("Z-Index Active", "activatedzIndex")}
      </div>
    );
  };

  const renderBackgroundProperties = (
    renderSelect,
    searchTerm,
    handleChange,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "background".includes(searchTerm.toLowerCase()) ||
        "image".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    const handleImageSelect = (imageName) => {
      setSelectedImage(imageName);
      handleChange({
        target: {
          name: "backgroundImage",
          value: `./${imageName}`,
        },
      });
    };

    return (
      <div key="background-properties" style={styles.inputGroup}>
        <div>
          <label style={styles.label}>Background Image URL: </label>
          <input
            type="text"
            name="backgroundImage"
            value={selectedDiv ? selectedDiv.backgroundImage : ""}
            onChange={handleChange}
            placeholder="Enter URL or select from File Manager"
            style={styles.input}
          />
          <button
            onClick={() => setShowFileManager(true)}
            style={styles.button}
          >
            Open File Manager
          </button>
        </div>
        {files.length > 0 && (
          <div style={styles.imageSelector}>
            <label style={styles.label}>Select an image:</label>
            <select
              onChange={(e) => handleImageSelect(e.target.value)}
              value={selectedImage || ""}
              style={styles.select}
            >
              <option value="">Choose an image</option>
              {files
                .filter((file) => file.type.startsWith("image/"))
                .map((file) => (
                  <option key={file.id} value={file.name}>
                    {file.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {renderSelect("Background Repeat", "backgroundRepeat", [
          "repeat",
          "no-repeat",
          "repeat-x",
          "repeat-y",
          "space",
          "round",
        ])}
        {renderSelect("Background Position", "backgroundPosition", [
          "left top",
          "left center",
          "left bottom",
          "right top",
          "right center",
          "right bottom",
          "center top",
          "center center",
          "center bottom",
        ])}
        {renderSelect("Background Size", "backgroundSize", [
          "auto",
          "cover",
          "contain",
        ])}
        {renderSelect("Background Attachment", "backgroundAttachment", [
          "scroll",
          "fixed",
          "local",
        ])}
        {renderSelect("Background Clip", "backgroundClip", [
          "border-box",
          "padding-box",
          "content-box",
        ])}
      </div>
    );
  };
  const renderhoveredBackgroundProperties = (
    renderSelect,
    searchTerm,
    handleChange,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "background".includes(searchTerm.toLowerCase()) ||
        "image".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    const handleImageSelect = (imageName) => {
      setSelectedHoveredImage(imageName);
      handleChange({
        target: {
          name: "hoveredbackgroundImage",
          value: `./${imageName}`,
        },
      });
    };

    return (
      <div key="hovered-background-properties" style={styles.inputGroup}>
        <div>
          <label style={styles.label}>Background Image Hover: </label>
          <input
            type="text"
            name="hoveredbackgroundImage"
            value={selectedDiv ? selectedDiv.hoveredbackgroundImage : ""}
            onChange={handleChange}
            placeholder="Enter URL or select from File Manager"
            style={styles.input}
          />
          <button
            onClick={() => setShowFileManager(true)}
            style={styles.button}
          >
            Open File Manager
          </button>
        </div>
        {files.length > 0 && (
          <div style={styles.imageSelector}>
            <label style={styles.label}>Select an image for hover:</label>
            <select
              onChange={(e) => handleImageSelect(e.target.value)}
              value={selectedHoveredImage || ""}
              style={styles.select}
            >
              <option value="">Choose an image</option>
              {files
                .filter((file) => file.type.startsWith("image/"))
                .map((file) => (
                  <option key={file.id} value={file.name}>
                    {file.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {renderSelect(
          "Background Repeat for hover",
          "hoveredbackgroundRepeat",
          ["repeat", "no-repeat", "repeat-x", "repeat-y", "space", "round"]
        )}
        {renderSelect(
          "Background Position for hover",
          "hoveredbackgroundPosition",
          [
            "left top",
            "left center",
            "left bottom",
            "right top",
            "right center",
            "right bottom",
            "center top",
            "center center",
            "center bottom",
          ]
        )}
        {renderSelect("Background Size for hover", "hoveredbackgroundSize", [
          "auto",
          "cover",
          "contain",
        ])}
        {renderSelect(
          "Background Attachment for hover",
          "hoveredbackgroundAttachment",
          ["scroll", "fixed", "local"]
        )}
        {renderSelect("Background Clip for hover", "hoveredbackgroundClip", [
          "border-box",
          "padding-box",
          "content-box",
        ])}
      </div>
    );
  };
  const renderactivatedBackgroundProperties = (
    renderSelect,
    searchTerm,
    handleChange,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "background".includes(searchTerm.toLowerCase()) ||
        "image".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    const handleImageSelect = (imageName) => {
      setSelectedActivatedImage(imageName);
      handleChange({
        target: {
          name: "activatedbackgroundImage",
          value: `./${imageName}`,
        },
      });
    };

    return (
      <div key="activated-background-properties" style={styles.inputGroup}>
        <div>
          <label style={styles.label}>Background Image Active: </label>
          <input
            type="text"
            name="activatedbackgroundImage"
            value={selectedDiv ? selectedDiv.activatedbackgroundImage : ""}
            onChange={handleChange}
            placeholder="Enter URL or select from File Manager"
            style={styles.input}
          />
          <button
            onClick={() => setShowFileManager(true)}
            style={styles.button}
          >
            Open File Manager
          </button>
        </div>
        {files.length > 0 && (
          <div style={styles.imageSelector}>
            <label style={styles.label}>
              Select an image for active state:
            </label>
            <select
              onChange={(e) => handleImageSelect(e.target.value)}
              value={selectedActivatedImage || ""}
              style={styles.select}
            >
              <option value="">Choose an image</option>
              {files
                .filter((file) => file.type.startsWith("image/"))
                .map((file) => (
                  <option key={file.id} value={file.name}>
                    {file.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {renderSelect(
          "Background Repeat for active",
          "activatedbackgroundRepeat",
          ["repeat", "no-repeat", "repeat-x", "repeat-y", "space", "round"]
        )}
        {renderSelect(
          "Background Position for active",
          "activatedbackgroundPosition",
          [
            "left top",
            "left center",
            "left bottom",
            "right top",
            "right center",
            "right bottom",
            "center top",
            "center center",
            "center bottom",
          ]
        )}
        {renderSelect("Background Size for active", "activatedbackgroundSize", [
          "auto",
          "cover",
          "contain",
        ])}
        {renderSelect(
          "Background Attachment for active",
          "activatedbackgroundAttachment",
          ["scroll", "fixed", "local"]
        )}
        {renderSelect("Background Clip for active", "activatedbackgroundClip", [
          "border-box",
          "padding-box",
          "content-box",
        ])}
      </div>
    );
  };
  const renderFocusedBackgroundProperties = (
    renderSelect,
    searchTerm,
    handleChange,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "background".includes(searchTerm.toLowerCase()) ||
        "image".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    const handleImageSelect = (imageName) => {
      setSelectedFocusedImage(imageName);
      handleChange({
        target: {
          name: "focusedbackgroundImage",
          value: `./${imageName}`,
        },
      });
    };

    return (
      <div key="focused-background-properties" style={styles.inputGroup}>
        <div>
          <label style={styles.label}>Background Image Focus: </label>
          <input
            type="text"
            name="focusedbackgroundImage"
            value={selectedDiv ? selectedDiv.focusedbackgroundImage : ""}
            onChange={handleChange}
            placeholder="Enter URL or select from File Manager"
            style={styles.input}
          />
          <button
            onClick={() => setShowFileManager(true)}
            style={styles.button}
          >
            Open File Manager
          </button>
        </div>
        {files.length > 0 && (
          <div style={styles.imageSelector}>
            <label style={styles.label}>Select an image for focus:</label>
            <select
              onChange={(e) => handleImageSelect(e.target.value)}
              value={selectedFocusedImage || ""}
              style={styles.select}
            >
              <option value="">Choose an image</option>
              {files
                .filter((file) => file.type.startsWith("image/"))
                .map((file) => (
                  <option key={file.id} value={file.name}>
                    {file.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {renderSelect(
          "Background Repeat for focus",
          "focusedbackgroundRepeat",
          ["repeat", "no-repeat", "repeat-x", "repeat-y", "space", "round"]
        )}
        {renderSelect(
          "Background Position for focus",
          "focusedbackgroundPosition",
          [
            "left top",
            "left center",
            "left bottom",
            "right top",
            "right center",
            "right bottom",
            "center top",
            "center center",
            "center bottom",
          ]
        )}
        {renderSelect("Background Size for focus", "focusedbackgroundSize", [
          "auto",
          "cover",
          "contain",
        ])}
        {renderSelect(
          "Background Attachment for focus",
          "focusedbackgroundAttachment",
          ["scroll", "fixed", "local"]
        )}
        {renderSelect("Background Clip for focus", "focusedbackgroundClip", [
          "border-box",
          "padding-box",
          "content-box",
        ])}
      </div>
    );
  };

  const renderGradientProperties = (
    renderSelect,
    searchTerm,
    renderInput,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "gradient".includes(searchTerm.toLowerCase()) ||
        "background".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    return (
      <div key="gradient-properties" style={styles.inputGroup}>
        {renderSelect("Background Gradient", "backgroundGradientImage", [
          "none",
          "linear-gradient",
          "radial-gradient",
          "repeating-linear-gradient",
          "repeating-radial-gradient",
        ])}

        {selectedDiv &&
          selectedDiv.backgroundGradientImage === "linear-gradient" && (
            <>
              {renderSelect("Gradient Direction", "gradientDirection", [
                "to right",
                "to bottom",
                "to left",
                "to top",
                "to top right",
                "to top left",
                "to bottom right",
                "to bottom left",
              ])}
            </>
          )}

        {selectedDiv &&
          selectedDiv.backgroundGradientImage === "radial-gradient" && (
            <>
              {renderSelect("Gradient Shape", "gradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect("Gradient Position", "gradientPosition", [
                "center",
                "top left",
                "top right",
                "bottom left",
                "bottom right",
                "top",
                "bottom",
                "left",
                "right",
              ])}
            </>
          )}

        {selectedDiv &&
          selectedDiv.backgroundGradientImage ===
            "repeating-linear-gradient" && (
            <>
              {renderInput("Gradient Angle (deg)", "gradientAngle", "number")}
              {renderInput("Pattern Length", "patternLength", "number")}
            </>
          )}

        {selectedDiv &&
          selectedDiv.backgroundGradientImage ===
            "repeating-radial-gradient" && (
            <>
              {renderSelect("Gradient Shape", "gradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect("Gradient Position", "gradientPosition", [
                "center",
                "top left",
                "top right",
                "bottom left",
                "bottom right",
                "top",
                "bottom",
                "left",
                "right",
              ])}
              {renderInput("Pattern Length", "patternLength", "number")}
            </>
          )}

        {renderInput("start Color", "startColor", "color")}
        {renderInput("End Color", "endColor", "color")}
      </div>
    );
  };
  const renderHoveredGradientProperties = (
    renderSelect,
    searchTerm,
    renderInput,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "gradient".includes(searchTerm.toLowerCase()) ||
        "background".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    return (
      <div key="gradient-properties" style={styles.inputGroup}>
        {renderSelect(
          "Background Gradient Hover",
          "hoveredbackgroundGradientImage",
          [
            "none",
            "linear-gradient",
            "radial-gradient",
            "repeating-linear-gradient",
            "repeating-radial-gradient",
          ]
        )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "hover" &&
          selectedDiv.hoveredbackgroundGradientImage === "linear-gradient" && (
            <>
              {renderSelect(
                "Gradient Direction Hover",
                "hoveredgradientDirection",
                [
                  "to right",
                  "to bottom",
                  "to left",
                  "to top",
                  "to top right",
                  "to top left",
                  "to bottom right",
                  "to bottom left",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "hover" &&
          selectedDiv.hoveredbackgroundGradientImage === "radial-gradient" && (
            <>
              {renderSelect("Gradient Shape Hover", "hoveredgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position Hover",
                "hoveredgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "hover" &&
          selectedDiv.hoveredbackgroundGradientImage ===
            "repeating-linear-gradient" && (
            <>
              {renderInput(
                "Gradient Angle Hover (deg)",
                "hoveredgradientAngle",
                "number"
              )}
              {renderInput(
                "Pattern Length Hover",
                "hoveredpatternLength",
                "number"
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "hover" &&
          selectedDiv.hoveredbackgroundGradientImage ===
            "repeating-radial-gradient" && (
            <>
              {renderSelect("Gradient Shape Hover", "hoveredgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position Hover",
                "hoveredgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
              {renderInput(
                "Pattern Length Hover",
                "hoveredpatternLength",
                "number"
              )}
            </>
          )}

        {renderInput("start Color Hover", "hoveredstartColor", "color")}
        {renderInput("End Color Hover", "hoveredendColor", "color")}
      </div>
    );
  };
  const renderFocusedGradientProperties = (
    renderSelect,
    searchTerm,
    renderInput,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "gradient".includes(searchTerm.toLowerCase()) ||
        "background".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    return (
      <div key="gradient-properties" style={styles.inputGroup}>
        {renderSelect(
          "Background Gradient Focus",
          "focusedbackgroundGradientImage",
          [
            "none",
            "linear-gradient",
            "radial-gradient",
            "repeating-linear-gradient",
            "repeating-radial-gradient",
          ]
        )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "focus" &&
          selectedDiv.focusedbackgroundGradientImage === "linear-gradient" && (
            <>
              {renderSelect(
                "Gradient Direction Focus",
                "focusedgradientDirection",
                [
                  "to right",
                  "to bottom",
                  "to left",
                  "to top",
                  "to top right",
                  "to top left",
                  "to bottom right",
                  "to bottom left",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "focus" &&
          selectedDiv.focusedbackgroundGradientImage === "radial-gradient" && (
            <>
              {renderSelect("Gradient Shape Focus", "focusedgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position Focus",
                "focusedgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "focus" &&
          selectedDiv.focusedbackgroundGradientImage ===
            "repeating-linear-gradient" && (
            <>
              {renderInput(
                "Gradient Angle Hover (deg)",
                "hoveredgradientAngle",
                "number"
              )}
              {renderInput(
                "Pattern Length Focus",
                "focusedpatternLength",
                "number"
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "focus" &&
          selectedDiv.focusedbackgroundGradientImage ===
            "repeating-radial-gradient" && (
            <>
              {renderSelect("Gradient Shape Focus", "focusedgradientShape", [
                "circle",
                "ellipse",
              ])}
              {renderSelect(
                "Gradient Position Focus",
                "focusedgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
              {renderInput(
                "Pattern Length Focus",
                "focusedpatternLength",
                "number"
              )}
            </>
          )}

        {renderInput("start Color Focus", "focusedstartColor", "color")}
        {renderInput("End Color Focus", "focusedendColor", "color")}
      </div>
    );
  };
  const renderActivatedGradientProperties = (
    renderSelect,
    searchTerm,
    renderInput,
    selectedDiv
  ) => {
    if (
      searchTerm &&
      !(
        "gradient".includes(searchTerm.toLowerCase()) ||
        "background".includes(searchTerm.toLowerCase()) ||
        "color".includes(searchTerm.toLowerCase())
      )
    ) {
      return null;
    }

    return (
      <div key="gradient-properties" style={styles.inputGroup}>
        {renderSelect(
          "Background Gradient Activate",
          "activatedbackgroundGradientImage",
          [
            "none",
            "linear-gradient",
            "radial-gradient",
            "repeating-linear-gradient",
            "repeating-radial-gradient",
          ]
        )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "activate" &&
          selectedDiv.activatedbackgroundGradientImage ===
            "linear-gradient" && (
            <>
              {renderSelect(
                "Gradient Direction Activate",
                "activatedgradientDirection",
                [
                  "to right",
                  "to bottom",
                  "to left",
                  "to top",
                  "to top right",
                  "to top left",
                  "to bottom right",
                  "to bottom left",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "activate" &&
          selectedDiv.activatedbackgroundGradientImage ===
            "radial-gradient" && (
            <>
              {renderSelect(
                "Gradient Shape Activate",
                "activatedgradientShape",
                ["circle", "ellipse"]
              )}
              {renderSelect(
                "Gradient Position Activate",
                "activatedgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "activate" &&
          selectedDiv.activatedbackgroundGradientImage ===
            "repeating-linear-gradient" && (
            <>
              {renderInput(
                "Gradient Angle Hover (deg)",
                "hoveredgradientAngle",
                "number"
              )}
              {renderInput(
                "Pattern Length Activate",
                "activatedpatternLength",
                "number"
              )}
            </>
          )}

        {selectedDiv &&
          selectedDiv.pseudoClass === "activate" &&
          selectedDiv.activatedbackgroundGradientImage ===
            "repeating-radial-gradient" && (
            <>
              {renderSelect(
                "Gradient Shape Activate",
                "activatedgradientShape",
                ["circle", "ellipse"]
              )}
              {renderSelect(
                "Gradient Position Activate",
                "activatedgradientPosition",
                [
                  "center",
                  "top left",
                  "top right",
                  "bottom left",
                  "bottom right",
                  "top",
                  "bottom",
                  "left",
                  "right",
                ]
              )}
              {renderInput(
                "Pattern Length Activate",
                "activatedpatternLength",
                "number"
              )}
            </>
          )}

        {renderInput("start Color Activate", "activatedstartColor", "color")}
        {renderInput("End Color Activate", "activatedendColor", "color")}
      </div>
    );
  };

  return (
    <PropertyContext.Provider
      value={{
        renderLabelMarginProperties,
        renderLabelPaddingProperties,
        renderLabelBorderProperties,
        renderLabelPositionProperties,
        renderLabelBackgroundProperties,
        renderLabelGradientProperties,

        renderMarginProperties,
        renderHoveredMarginProperties,
        renderFocusedMarginProperties,
        renderActivatedMarginProperties,

        renderPaddingProperties,
        renderHoveredPaddingProperties,
        renderFocusedPaddingProperties,
        renderActivatedPaddingProperties,

        renderBorderProperties,
        renderHoveredBorderProperties,
        renderFocusedBorderProperties,
        renderActivatedBorderProperties,

        renderPositionProperties,
        renderHoveredPositionProperties,
        renderFocusedPositionProperties,
        renderActivatedPositionProperties,

        renderBackgroundProperties,
        renderhoveredBackgroundProperties,
        renderactivatedBackgroundProperties,
        renderFocusedBackgroundProperties,

        renderGradientProperties,
        renderHoveredGradientProperties,
        renderFocusedGradientProperties,
        renderActivatedGradientProperties,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export { PropertyContext, PropertyProvider };
